<div class="geometry-map">
  <div class="geometry-map__toolbar">
    <input
      #geometryFile
      type="file"
      hidden
      [accept]="accept"
      (change)="onFileSelected($event)"
    />
    <app-secondary-button
      title="Load KML or GeoJSON"
      icon="pi pi-upload"
      size="small"
      (action)="openFilePicker()"
    ></app-secondary-button>
    @if (fileName()) {
      <span class="geometry-map__file">{{ fileName() }}</span>
    }
  </div>
  @if (errorMessage()) {
    <div class="geometry-map__error">{{ errorMessage() | translate }}</div>
  }
  <p class="geometry-map__hint">{{ 'Draw the search area on the map' | translate }}</p>
  <app-orchestration-aoi-map
    [wkt]="mapPolygonJson() ?? ''"
    (wktChange)="onMapWkt($event)"
  ></app-orchestration-aoi-map>
</div>
